import {Provider} from "@angular/core";
import {TEST_MODULE_REGISTRY, TestModuleDefinition} from "../../../core/shared/test/data/test-harness.types";
import {
    EmSchemaObjectComponent
} from "../component/object-components/object-component/em-schema-object-component/em-schema-object.component";
import {
    EmSchemaObjectFullComponent
} from "../component/object-components/object-component/em-schema-object-component/view/em-schema-object-component-full/em-schema-object-full.component";
import {
    EmSchemaObjectSideComponent
} from "../component/object-components/object-component/em-schema-object-component/view/em-schema-object-component-side/em-schema-object-side.component";
import {
    SchemaNodeComponent
} from "../component/object-components/object-component/em-schema-object-component/view/shared/schema-node-component/schema-node.component";
import {
    SchemaRuntimeComponent
} from "../component/object-components/object-component/em-schema-object-component/view/shared/schema-runtime-component/schema-runtime.component";
import {
    SchemaStructureComponent
} from "../component/object-components/object-component/em-schema-object-component/view/shared/schema-structure-component/schema-structure.component";
import {
    SchemaRuntimeOptimizedComponent
} from "../component/object-components/object-component/em-schema-object-component/view/shared/schema-runtime-optimized/schema-runtime-optimized.component";
import {
    EmSchemaObjectBaseComponent
} from "../component/object-components/object-component/em-schema-object-component/view/em-schema-object-base.component";
import {ObjectBaseComponent} from "../../../core/shared/object/mvs-object-base/object-base.component";
import {EmConfigPage} from "../page/overview/em-config/em-config.page";

const emModuleEntry: TestModuleDefinition = {
    key: 'em',
    label: 'Entity Manager (em)',
    components: [
        {
            key: 'emSchemaObjectComponent',
            component: EmSchemaObjectComponent,
            selector: 'em-schema-object-component',
            type: 'ObjectBaseComponent',
            label: 'Schema Object'
        },
        {
            key: 'emSchemaObjectFullComponent',
            component: EmSchemaObjectFullComponent,
            selector: 'em-schema-object-component-full',
            type: 'EmSchemaObjectBaseComponent',
            label: 'Schema Object Full View'
        },
        {
            key: 'emSchemaObjectSideComponent',
            component: EmSchemaObjectSideComponent,
            selector: 'em-schema-object-component-side',
            type: 'EmSchemaObjectBaseComponent',
            label: 'Schema Object Side View'
        },
        {
            key: 'schemaNodeComponent',
            component: SchemaNodeComponent,
            selector: 'em-schema-node-data',
            type: 'component',
            label: 'Schema Node'
        },
        {
            key: 'schemaRuntimeComponent',
            component: SchemaRuntimeComponent,
            selector: 'em-schema-runtime-data',
            type: 'component',
            label: 'Schema Runtime'
        },
        {
            key: 'schemaStructureComponent',
            component: SchemaStructureComponent,
            selector: 'em-schema-structure',
            type: 'component',
            label: 'Schema Structure'
        },
        {
            key: 'schemaRuntimeOptimizedComponent',
            component: SchemaRuntimeOptimizedComponent,
            selector: 'em-schema-runtime-optimized',
            type: 'component',
            label: 'Schema Runtime Optimiert'
        },
        {
            key: 'EmConfigPage',
            component: EmConfigPage,
            selector: 'mvs-em-config',
            type: 'PageComponent',
            label: 'mvs em config'
        }
    ]
};

export const EM_TEST_PROVIDERS: Provider[] = [
    { provide: TEST_MODULE_REGISTRY, useValue: emModuleEntry, multi: true }
];